import 'prefixfree';
import Modernizr from 'browsernizr';
import './jquery';
import './easing';
import './magnific';
import './simple-dd';
import './select2';
import './datepicker';
import './enllax';
import './slick';
import VanillaCalendar from 'vanilla-calendar-pro';
import twire from './twire';
import AOS from 'aos';
import intlTelInput from 'intl-tel-input';



'use strict';


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $main 			= $('main');
var $footer 		= $('footer');
var $mobileMenu 	= $('div.mobile-menu');



/**
 * Run TWire functions
 */
twire.init();


/**
 * Phone input
 */
var phoneInput = document.querySelector('main input[name="phone"]');

if (phoneInput !== null) {

	var iti = intlTelInput(phoneInput, {

	    utilsScript: './intl-tel-input-utils.js',
		initialCountry: 'auto',
		geoIpLookup: function(success, failure) {

			fetch('https://ipapi.co/json')
			.then(function(res) { return res.json(); })
			.then(function(data) { success(data.country_code); })
			.catch(function() { failure(); });

		},
		separateDialCode: true,
		strictMode: true

	});

}


/**
 * Menu highlight
 */
$header.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]').addClass('active');
$header.find('span.drop-down span.child a.active').each(function() {

	$(this).closest('span.drop-down')
	       .children('a')
		   .addClass('active');

});


/**
 * Drop down
 */
$header.find('span.drop-down')
       .simpleDD({

	dropdownElement: 'span.child',
	noScriptLink:    '> a'

});


/**
 * Mobile menu content
 */
$mobileMenu.find('div.inner')
           .html($header.find('div.content').html());

$mobileMenu.find('div.menu')
           .remove();


/**
 * Mobile menu behaviour
 */
$header.find('div.menu a')
       .on('click', function(e) {

	e.preventDefault();

	$mobileMenu.addClass('active');

});

$mobileMenu.find('a.close')
       .on('click', function(e) {

	e.preventDefault();

	$mobileMenu.removeClass('active');

});


/**
 * Generic lightboxes
 */
$('a.lightbox.video').magnificPopup({

	type: 'iframe',
	mainClass: 'lightbox-effect',

});

$('a.lightbox.inline').magnificPopup({

	type: 'inline',
	mainClass: 'lightbox-effect',

});

$('a.lightbox.image').magnificPopup({

	type: 'image',
	mainClass: 'lightbox-effect',

});

$('div.gallery').magnificPopup({

	delegate: 'a',
	type: 'image',
	mainClass: 'lightbox-effect',
	gallery: {

		enabled: true,
		navigateByImgClick: true,
		preload: [0,1]

	}

});


/**
 * Alt header
 */
$window.on('scroll resize', function() {

    if ($window.scrollTop() > 120) {

        $header.addClass('alt');

    } else {

        $header.removeClass('alt');

    }

});


/**
 * Enllax
 */
$window.enllax();


/**
 * AOS
 */
AOS.init({

	once: true

});


/**
 * Site messages
 */
$('div.site-message').each(function() {

	var $this = $(this);

	var icon = 'check-circle';

	if ($this.hasClass('warning') === true) {

		var icon = 'exclamation-circle';

	} else if ($this.hasClass('notice') === true) {

		var icon = 'info-circle';

	} else if ($this.hasClass('error') === true) {

		var icon = 'emoji-frown';

	}

	$this.append('<a class="bi bi-x close"></a>')
	     .prepend('<span class="bi bi-' + twire.util.html(icon) + '"></span> ')
	     .find('a.close')
		 .on('click', function(e) {

		$(this).closest('div.site-message')
		       .remove();

	});
	
	if ($this.hasClass('unclosable') === true) {
		
		$this.find('a.close').remove();
		
	}

});


/**
 * Calendar
 */
$('body.property main div.calendar').each(function() {

	function formatMoney(money) {

		return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

	}

	var $this = $(this);

	var $form = $main.find('form.booking-step-1');

	var selected = $this.data('selected');

	var calendar = new VanillaCalendar($this[0], {

		settings: {

			selection: {

				day: 'multiple-ranged'

			},
			visibility: {

				theme: 	'light',
				weekend: false
			
			},
			range: {

				min: 	  $this.data('min'),
				max: 	  $this.data('max'),
				disabled: $this.data('booked-days')

			},
			selected: selected

		},
		actions: {

			clickDay(event, self) {

				// If only a single date selected, disable the form but do nothing else
				if (self.selectedDates.length === 1) {

					$form.addClass('disabled')
					     .removeClass('invalid-dates valid min-stay-invalid');

						 return;

				}

				// Get rid of initial message
				// Do it after both dates selected for better UX
				$main.find('div.site-message.initial-message')
				     .remove();

				// Get min stay based on first day selected
				// Due to their data structure it could straddle different min stays but that can't be helped
				var minStays = $this.data('min-stays');

				// Update min. stay based on dates regardless of choice
				$main.find('span.min-stay-nights')
				     .text(minStays[self.selectedDates[0]]);

				// Now show these as they'll have a valid value
				$main.find('div.hide-on-load')
				     .addClass('active');

				// Ensure min. days
				if ((self.selectedDates.length - 1) < minStays[self.selectedDates[0]]) { // -1 is due to the fact the last day is check-out, not a "night"


					$form.addClass('disabled min-stay-invalid')
					     .removeClass('invalid-dates valid');

						 return;

				}

				// Check against disabled
				var validDates = true;

				$.each(self.selectedDates, function(index, value) {

					if ($.inArray(value, $this.data('booked-days')) !== -1) {

						validDates = false;

					}

				});

				// If disabled, disable form and show message
				if (validDates === false) {

					$form.addClass('disabled invalid-dates')
					     .reoveClass('valid min-stay-invalid');

					// Update inputs
					$form.find('input[name="check-in-date"]')
					     .val('');

					$form.find('input[name="check-out-date"]')
					     .val('');

				} else {

					$form.removeClass('disabled invalid-dates min-stay-invalid')
					     .addClass('valid');

					var $showDates = $main.find('div.show-dates');

					// Set num nights 
					$showDates.find('span.num-nights')
					          .text(self.selectedDates.length - 1); // -1 for check out as above

					var total		= 0;
					var nights		= [];
					var dailyFees 	= $this.data('daily-fees');

					// Get nights, but leave out the last one as they are leaving that day, not staying the night
					var counter	= 1;
					var length 	= self.selectedDates.length;

					$.each(self.selectedDates, function(index, value) {

						var costForNight = parseInt(dailyFees[value] * 100); // Do in cents to avoid floating point inaccuracies

						if (counter < length) {

							total += costForNight;

							nights.push({

								night:	value,
								cost: 	costForNight

							});

						}

						counter ++;

					});

					// Set total cost 
					total = total / 100;

					$showDates.find('span.total')
					          .text(formatMoney(total));

					// Set individual details in lightbox
					var html = '<h2>Cost per night</h2><div class="lightbox-costs">';

					for (var counter = 0; counter < nights.length; counter ++) {

						html += '<div class="row"><div class="date">' + twire.util.html(nights[counter].night) + '</div><div class="value">€' + twire.util.html(formatMoney(nights[counter].cost / 100)) + '</div></div>';

					}

					html += '<div class="row total"><div class="date">Total</div><div class="value">€' + twire.util.html(formatMoney(total)) + '</div></div></div>';

					$('#cost-per-night').html(html);

					$form.find('input[name="check-in-date"]')
					     .val(self.selectedDates[0]);

					$form.find('input[name="check-out-date"]')
					     .val(self.selectedDates[self.selectedDates.length - 1]);

				}

			}

		}

	});

	calendar.init();

});


/**
 * Scroll links
 */
$('a[data-scroll-to]').on('click', function(e) {

	e.preventDefault();
	
	$htmlBody.animate({

		scrollTop: $($(this).data('scroll-to')).offset().top - 70 // $headerHeightAlt

	}, 1000, 'easeInOutExpo');

}).addClass('active');


/**
 * Property panels
 */

var $panels = $('body.property main div.panel');

// Hide panels
$panels.addClass('inactive');

// Panels open and close
$panels.find('h2')
       .on('click', function() {

	var $this = $(this);

	$this.closest('div.panel')
	     .toggleClass('inactive');

});


/**
 * Property gallery
 */
$('body.property main div.images a.button[href="#"]').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.closest('div.images')
	     .find('div.gallery')
		 .addClass('active');

	$this.remove();

});


/**
 * Proeprty search form mobile
 */
$main.find('div.banner-image div.toggle a')
     .one('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.closest('div.banner-image')
	     .find('form')
		 .addClass('active');

	$this.remove();

});


/**
 * Property load more
 */
$('body:not(.home) main div.properties').each(function() {

	var $this = $(this);

	var $properties = $this.find('div.property');

	var $button = $this.next()
	                   .find('a.button');

	var currentPage = $this.data('current-page');
	var totalPages  = $this.data('total-pages');

	$button.on('click', function(e) {

		e.preventDefault();

		currentPage ++;

		$properties.filter('*[data-page="' + parseInt(currentPage) + '"]')
				   .addClass('active');

		if (currentPage == totalPages) {

			$button.remove();

		}

	})

});


/**
 * Select2
 */
$('select:not([data-search])').select2({

	width:                   '100%',
	minimumResultsForSearch: -1

});

$('select[data-search]').select2({

	width: '100%'

});


/**
 * Date picker
 */

$('input[name="check-in-date"], input[name="check-out-date"]').datepicker({

	format: 	'yyyy-mm-dd', // PHP strtotime works with UK dates if using full stops, not forward slashes
	weekStart: 	1,
	startDate:  new Date() // Prevent going in the past
});


/**
 * Slick
 */
$('div[data-slick]').slick();


/**
 * Home video defer
 */
$window.on('load', function() {

	var $video = $('body.home main div.video');

	$video.html($video.data('html'));

});


$('body.property').each(function() {

	var imgHTML = $main.find('template.image')
	                   .html();

	imgHTML = '<p>' + imgHTML + '</p>';

	if ($('div.description p').length > 0) {

		$('div.description p:first').after(imgHTML);

	} else {

		$('div.description').append(imgHTML);

	}

});


/**
 * Triggers
 */
$window.trigger('resize');
$window.trigger('scroll');
